import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const next = loc.state?.from || "/episodes";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("welcome back ♡");
      nav(next);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-5 py-12" data-testid="login-page">
      <div className="w-full max-w-md">
        <p className="scribble text-hotpink text-2xl mb-2 rotate-[-2deg] inline-block">welcome back, gorgeous</p>
        <h1 className="brush-title text-5xl md:text-6xl text-white mb-8">LOG <span className="text-hotpink">IN.</span></h1>

        <form onSubmit={submit} className="bg-coal border border-white/10 p-7 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none" placeholder="you@dating.disaster" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-sm px-6 py-4 shadow-[4px_4px_0px_#FFFFFF] hover:shadow-[6px_6px_0px_#FFFFFF] transition-all disabled:opacity-60">
            {loading ? "..." : "log in"}
          </button>
          <p className="text-white/60 text-sm font-outfit text-center">
            new here? <Link to="/signup" data-testid="login-to-signup" className="text-hotpink underline underline-offset-4">make an account</Link>
          </p>
          <p className="text-white/40 text-xs font-outfit text-center">
            forgot? <Link to="/forgot-password" data-testid="login-to-forgot" className="text-hotpink underline underline-offset-4">reset your password</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
